import React, { ChangeEvent } from 'react';

import styles from './CommentBlock.module.scss';

type OnChangeProps =
  | {
      /**
       * If true, the onChange call back will receive a
       * string instead of a ChangeEvent
       */
      provideValueOnChange: true;
      onChange?: (value: string) => void;
    }
  | {
      provideValueOnChange?: false;
      onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    };

type CommentBlockProps = {
  commentPlaceholder: string;
  value: string;
  disabled?: boolean;
} & OnChangeProps;

export const CommentBlock = ({
  commentPlaceholder,
  value,
  provideValueOnChange,
  onChange,
  disabled,
}: CommentBlockProps) => {
  if (!commentPlaceholder) return null;

  const handleOnChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    if (provideValueOnChange) {
      onChange?.(event.target.value);
    } else {
      onChange?.(event);
    }
  };

  return (
    <div>
      <textarea
        className={styles.textArea}
        rows={5}
        value={value}
        onChange={handleOnChange}
        placeholder={commentPlaceholder}
        disabled={disabled}
      />
    </div>
  );
};
